import React from 'react';
import Slider from '../shared/Slider';

const Photo = ({ content, className }) => {
  return (
    <Slider post={content} className={className} />
  )
}

export default Photo;